/** Minimal 24×24 stroke icons for navigation and cards */

const stroke = {
  stroke: 'currentColor',
  strokeWidth: 1.75,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  fill: 'none',
};

export function IconDashboard({ className = 'h-5 w-5 shrink-0' }) {
  return (
    <svg className={className} viewBox="0 0 24 24" aria-hidden {...stroke}>
      <path d="M4 10.5V20h6v-6h4v6h6v-9.5M4 10.5l8-6 8 6" />
    </svg>
  );
}

export function IconUpload({ className = 'h-5 w-5 shrink-0' }) {
  return (
    <svg className={className} viewBox="0 0 24 24" aria-hidden {...stroke}>
      <path d="M12 4v12M8 8l4-4 4 4M4 20h16" />
    </svg>
  );
}

export function IconPackage({ className = 'h-5 w-5 shrink-0' }) {
  return (
    <svg className={className} viewBox="0 0 24 24" aria-hidden {...stroke}>
      <path d="M4 8l8-4 8 4v8l-8 4-8-4V8z M4 8l8 4 8-4 M12 12v9" />
    </svg>
  );
}

export function IconAlert({ className = 'h-5 w-5 shrink-0' }) {
  return (
    <svg className={className} viewBox="0 0 24 24" aria-hidden {...stroke}>
      <path d="M12 9v4M12 17h.01M10.3 4.8L3.2 17.5A2 2 0 004.9 20h14.2a2 2 0 001.7-2.5L13.7 4.8a2 2 0 00-3.4 0z" />
    </svg>
  );
}

export function IconBuilding({ className = 'h-5 w-5 shrink-0' }) {
  return (
    <svg className={className} viewBox="0 0 24 24" aria-hidden {...stroke}>
      <path d="M4 20V8l8-4v16M4 12h8M9 8v1M9 12v1M9 16v1M14 8h6v12" />
    </svg>
  );
}

export function IconInbox({ className = 'h-5 w-5 shrink-0' }) {
  return (
    <svg className={className} viewBox="0 0 24 24" aria-hidden {...stroke}>
      <path d="M4 14l2.5-5h11L20 14v4H4v-4z M8 9V6a4 4 0 018 0v3" />
    </svg>
  );
}

export function IconSearch({ className = 'h-5 w-5 shrink-0' }) {
  return (
    <svg className={className} viewBox="0 0 24 24" aria-hidden {...stroke}>
      <circle cx="11" cy="11" r="7" />
      <path d="M20 20l-4-4" />
    </svg>
  );
}

export function IconChart({ className = 'h-5 w-5 shrink-0' }) {
  return (
    <svg className={className} viewBox="0 0 24 24" aria-hidden {...stroke}>
      <path d="M4 19V5M8 19v-6M12 19V9M16 19v-3M20 19v-8" />
    </svg>
  );
}

export function IconVault({ className = 'h-5 w-5 shrink-0' }) {
  return (
    <svg className={className} viewBox="0 0 24 24" aria-hidden {...stroke}>
      <rect x="5" y="10" width="14" height="11" rx="1" />
      <path d="M9 10V7a3 3 0 016 0v3M12 14v2" />
    </svg>
  );
}

export function IconLink({ className = 'h-5 w-5 shrink-0' }) {
  return (
    <svg className={className} viewBox="0 0 24 24" aria-hidden {...stroke}>
      <path d="M10 14L8 12a4 4 0 010-5.7l1-1a4 4 0 015.6 0l1 1M14 10l2 2a4 4 0 010 5.7l-1 1a4 4 0 01-5.6 0l-1-1" />
    </svg>
  );
}

export function IconSpark({ className = 'h-5 w-5 shrink-0' }) {
  return (
    <svg className={className} viewBox="0 0 24 24" aria-hidden {...stroke}>
      <path d="M12 3l1.8 5.5H19l-4.5 3.3 1.7 5.4L12 15.9 7.8 17.2l1.7-5.4L5 8.5h5.2L12 3z" />
    </svg>
  );
}

export function IconBell({ className = 'h-5 w-5 shrink-0' }) {
  return (
    <svg className={className} viewBox="0 0 24 24" aria-hidden {...stroke}>
      <path d="M6 10a6 6 0 1112 0c0 5 2 5 2 5H4s2 0 2-5M10 18a2 2 0 004 0" />
    </svg>
  );
}

export function IconInfo({ className = 'h-5 w-5 shrink-0' }) {
  return (
    <svg className={className} viewBox="0 0 24 24" aria-hidden {...stroke}>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 11v5M12 8h.01" />
    </svg>
  );
}

export function IconChevronDown({ className = 'h-4 w-4 shrink-0' }) {
  return (
    <svg className={className} viewBox="0 0 24 24" aria-hidden {...stroke}>
      <path d="M6 9l6 6 6-6" />
    </svg>
  );
}

export function IconPanelLeft({ className = 'h-5 w-5 shrink-0' }) {
  return (
    <svg className={className} viewBox="0 0 24 24" aria-hidden {...stroke}>
      <rect x="3" y="4" width="18" height="16" rx="2" />
      <path d="M9 4v16" />
    </svg>
  );
}

export function IconShield({ className = 'h-5 w-5 shrink-0' }) {
  return (
    <svg className={className} viewBox="0 0 24 24" aria-hidden {...stroke}>
      <path d="M12 3l8 3v6c0 5-3.5 8.5-8 9.5C7.5 20.5 4 17 4 12V6l8-3z" />
      <path d="M9.5 12l1.8 1.8L15 10" />
    </svg>
  );
}

export function IconClipboard({ className = 'h-5 w-5 shrink-0' }) {
  return (
    <svg className={className} viewBox="0 0 24 24" aria-hidden {...stroke}>
      <rect x="6" y="5" width="12" height="16" rx="2" />
      <path d="M9 5V4h6v1M9 11h6M9 15h4" />
    </svg>
  );
}

export function IconLayers({ className = 'h-5 w-5 shrink-0' }) {
  return (
    <svg className={className} viewBox="0 0 24 24" aria-hidden {...stroke}>
      <path d="M12 4l8 4-8 4-8-4 8-4zM4 12l8 4 8-4M4 16l8 4 8-4" />
    </svg>
  );
}

export function IconPlug({ className = 'h-5 w-5 shrink-0' }) {
  return (
    <svg className={className} viewBox="0 0 24 24" aria-hidden {...stroke}>
      <path d="M9 3v5M15 3v5M6 8h12v2a6 6 0 01-12 0V8zM12 16v5" />
    </svg>
  );
}

export function IconSettings({ className = 'h-5 w-5 shrink-0' }) {
  return (
    <svg className={className} viewBox="0 0 24 24" aria-hidden {...stroke}>
      <circle cx="12" cy="12" r="3" />
      <path d="M19.4 15a1.7 1.7 0 00.3 1.8l.1.1a2 2 0 01-2.8 2.8l-.1-.1a1.7 1.7 0 00-1.8-.3 1.7 1.7 0 00-1 1.5V21a2 2 0 01-4 0v-.1a1.7 1.7 0 00-1-1.5 1.7 1.7 0 00-1.8.3l-.1.1a2 2 0 01-2.8-2.8l.1-.1a1.7 1.7 0 00.3-1.8 1.7 1.7 0 00-1.5-1H3a2 2 0 010-4h.1a1.7 1.7 0 001.5-1 1.7 1.7 0 00-.3-1.8l-.1-.1a2 2 0 012.8-2.8l.1.1a1.7 1.7 0 001.8.3H9a1.7 1.7 0 001-1.5V3a2 2 0 014 0v.1a1.7 1.7 0 001 1.5 1.7 1.7 0 001.8-.3l.1-.1a2 2 0 012.8 2.8l-.1.1a1.7 1.7 0 00-.3 1.8V9c.3.6.9 1 1.5 1H21a2 2 0 010 4h-.1a1.7 1.7 0 00-1.5 1z" />
    </svg>
  );
}

/** Figma header bell (UMB eVault 1:753). */
export function IconBellSolid({ className = 'h-[18px] w-[18px] shrink-0' }) {
  return (
    <svg className={className} viewBox="0 0 18 18" fill="currentColor" aria-hidden>
      <path d="M6.264 15.181A3.74 3.74 0 0 0 9 16.5c1.114 0 2.105-.517 2.736-1.319a20.4 20.4 0 0 1-5.472 0Z" />
      <path d="M14.062 6.75v.528c0 .634.181 1.253.52 1.78l.83 1.293c.76 1.18.18 2.784-1.14 3.158a21.4 21.4 0 0 1-10.544 0c-1.32-.374-1.9-1.978-1.14-3.158l.83-1.292c.34-.528.52-1.147.52-1.781V6.75C3.938 3.85 6.204 1.5 9 1.5s5.062 2.35 5.062 5.25Z" />
    </svg>
  );
}

/** Figma header info mark (UMB eVault 5:706). */
export function IconInfoSolid({ className = 'h-4 w-4 shrink-0' }) {
  return (
    <svg className={className} viewBox="0 0 16 16" fill="currentColor" aria-hidden>
      <path
        fillRule="evenodd"
        d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0Zm1.333 8A1.333 1.333 0 0 0 8 6.667H6.667V8H8v4.667h1.333V8ZM8 3.333a1 1 0 1 1 0 2 1 1 0 0 1 0-2Z"
      />
    </svg>
  );
}

/** Figma profile chevron (UMB eVault 1:777). */
export function IconChevronSquare({ className = 'h-[18px] w-[18px] shrink-0' }) {
  return (
    <svg className={className} viewBox="0 0 18 18" fill="currentColor" aria-hidden>
      <path
        fillRule="evenodd"
        d="M8.957.938h.086c1.731 0 3.088 0 4.147.142 1.083.146 1.938.45 2.61 1.12.67.672.974 1.527 1.12 2.611.142 1.059.142 2.416.142 4.147v.086c0 1.731 0 3.088-.142 4.147-.146 1.083-.45 1.938-1.12 2.61-.672.67-1.527.974-2.61 1.12-1.06.142-2.416.142-4.147.142h-.086c-1.731 0-3.088 0-4.147-.142-1.083-.146-1.938-.45-2.61-1.12-.67-.672-.974-1.527-1.12-2.61C.938 12.131.938 10.774.938 9.043v-.086c0-1.731 0-3.088.142-4.147.146-1.084.45-1.939 1.12-2.61.672-.671 1.527-.975 2.61-1.121C5.869.938 7.226.938 8.957.938ZM2.063 9c0-1.784.001-3.065.132-4.04.129-.959.374-1.537.801-1.964.427-.427 1.005-.672 1.964-.801C5.935 2.064 7.216 2.063 9 2.063c1.784 0 3.065.001 4.04.132.959.129 1.537.374 1.964.801.427.427.672 1.005.801 1.964.131.975.132 2.256.132 4.04 0 1.784-.001 3.065-.132 4.04-.129.959-.374 1.537-.801 1.964-.427.427-1.005.672-1.964.801-.975.131-2.256.132-4.04.132-1.784 0-3.065-.001-4.04-.132-.959-.129-1.537-.374-1.964-.801-.427-.427-.672-1.005-.801-1.964C2.064 12.065 2.063 10.784 2.063 9Zm4.29-1.523a.562.562 0 0 1 .794 0L9 9.33l1.852-1.853a.563.563 0 0 1 .796.796l-2.25 2.25a.563.563 0 0 1-.796 0l-2.25-2.25a.562.562 0 0 1 0-.795Z"
      />
    </svg>
  );
}

/** Figma sidebar collapse control (UMB eVault 453:6471). */
export function IconNavCollapse({ className = 'h-6 w-6 shrink-0' }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden>
      <path
        fillRule="evenodd"
        d="M17.4 4.364a3 3 0 0 1 3 3v9.273a3 3 0 0 1-3 3H6.6a3 3 0 0 1-3-3V7.364a3 3 0 0 1 3-3h10.8Zm-4.775 1.528a2 2 0 0 0-2 2v8.218a2 2 0 0 0 2 2h4.095a2 2 0 0 0 2-2V7.892a2 2 0 0 0-2-2h-4.095Z"
      />
    </svg>
  );
}

/** Figma column filter/sort control (UMB eVault 282:48781). */
export function IconTableFilter({ className = 'h-[18px] w-[18px] shrink-0' }) {
  return (
    <svg className={className} viewBox="0 0 18 18" fill="currentColor" aria-hidden>
      <path
        fillRule="evenodd"
        d="M17.063 5.25c0 .311-.252.563-.563.563H1.5a.563.563 0 0 1 0-1.125h15c.31 0 .563.252.563.562Z"
      />
      <path
        fillRule="evenodd"
        d="M14.813 9c0 .311-.253.563-.563.563H3.75a.563.563 0 1 1 0-1.125h10.5c.31 0 .563.251.563.562Z"
      />
      <path
        fillRule="evenodd"
        d="M12.563 12.75c0 .311-.253.563-.563.563H6a.563.563 0 0 1 0-1.125h6c.31 0 .563.252.563.562Z"
      />
    </svg>
  );
}
